export const INLINE_1 = 'Inline1';
export const INLINE_2 = 'Inline2';
export const COLUMN_1 = 'Column1';
export const COLUMN_2 = 'Column2';
export const COMPOSITE_1 = 'Composite1';
